import React from 'react';
import { graphql, compose, withApollo } from 'react-apollo';
import LATEST_PRODUCTIONS_QUERY from '../../../graphql/LatestProductions';
import LATEST_THEATERS_QUERY from '../../../graphql/LatestTheaters';
import LATEST_ARTISTS_QUERY from '../../../graphql/LatestArtists';
import SearchBar from '../../../components/SearchBar';
import Banner from '../../../components/Banner';
import Footer from '../../../components/Footer';
import Slideshow from '../../Others/Slideshow';
import IsGuest from '../../../utils/IsGuest';
import ProductionCard from '../../../components/Cards/ProductionCard';
import { ArtistCard, TheaterCard } from '../../../components/Cards';

class LandingPage extends React.Component {
  constructor(props) {
    super(props);

    const message = props.location.state && props.location.state.msg;

    this.state = {
      message,
    };
  }

  onSearch(terms) {
    if (!{}.hasOwnProperty.call(terms, 'advanced') || terms.advanced === false) {
      this.props.history.push(`/search/${terms.query}`);
    } else {
      let path = '/search/elements';
      if (terms.kind === 'productions') {
        path = '/search/productions';
      }
      this.props.history.push({
        pathname: path,
        state: terms,
      });
    }
  }

  render() {
    const {
      premiumProductions,
      freeProductions,
      premiumTheaters,
      freeTheaters,
      artists,
    } = this.props;

    const isGuest = IsGuest();

    const {
      message,
    } = this.state;

    return (
      <div>
        <Banner />
        <div className="banner text-center hidden-xs">
          <Slideshow title={(<p>¿Buscas producciones para tu teatro?<br /> Suscríbete a Escena y encuéntralas</p>)} />
          <SearchBar onSearch={terms => this.onSearch(terms)} float />
        </div>
        <SearchBar onSearch={terms => this.onSearch(terms)} mobile />
        <div className="recent-properties">
          <div className="container">
            <div className="main-title">
              {message && (
                <div className="alert alert-info">
                  {message}
                </div>
              )}
              <h1>Últimas producciones</h1>
              <div className="border">
                <div className="border-inner" />
              </div>
            </div>
            <div className="row">
              {premiumProductions && premiumProductions.map(production => (
                <ProductionCard
                  key={production.id}
                  production={production}
                  hideInfo={isGuest}
                />
                ))}
            </div>
            <div className="row">
              {freeProductions && freeProductions.map(production => (
                <ProductionCard
                  key={production.id}
                  production={production}
                  hideInfo={isGuest}
                />
              ))}
            </div>

            <div className="main-title">
              <h1>Últimos teatros</h1>
              <div className="border">
                <div className="border-inner" />
              </div>
            </div>
            <div className="row">
              {premiumTheaters && premiumTheaters.map(theater => (
                <TheaterCard
                  key={theater.id}
                  theater={theater}
                />
              ))}
            </div>
            <div className="row">
              {freeTheaters && freeTheaters.map(theater => (
                <TheaterCard
                  key={theater.id}
                  theater={theater}
                />
              ))}
            </div>

            <div className="main-title">
              <h1>Últimos artistas</h1>
              <div className="border">
                <div className="border-inner" />
              </div>
            </div>
            <div className="row">
              {artists && artists.map(artist => (
                <ArtistCard
                  key={artist.id}
                  artist={artist}
                />
              ))}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const withLatestProductions = graphql(LATEST_PRODUCTIONS_QUERY, {
  props: ({ data }) => {
    const latest = data.latestProductions || {};
    return {
      loadingLatest: data.loading,
      premiumProductions: latest.premium,
      freeProductions: latest.free,
    };
  },
  options: {
    fetchPolicy: 'cache-first',
    variables: {
      limit: 3,
    },
  },
});

const withLatestArtists = graphql(LATEST_ARTISTS_QUERY, {
  props: ({ data }) => ({
    loadingLatestArtists: data.loading,
    artists: data.latestArtists,
  }),
  options: {
    fetchPolicy: 'cache-first',
    variables: {
      limit: 3,
    },
  },
});

const withLatestTheaters = graphql(LATEST_THEATERS_QUERY, {
  props: ({ data }) => {
    const latest = data.latestTheaters || {};
    return {
      loadingLatestTheaters: data.loading,
      premiumTheaters: latest.premium,
      freeTheaters: latest.free,
    };
  },
  options: {
    fetchPolicy: 'cache-first',
    variables: {
      limit: 3,
    },
  },
});

export default compose(
  withApollo,
  withLatestProductions,
  withLatestTheaters,
  withLatestArtists,
)(LandingPage);



// WEBPACK FOOTER //
// ./src/containers/General/LandingPage/index.js